export const groupByDate = (data, grouping) => {
  const map = {};

  for (const { date, user_role, number } of data) {
    let dateGroupped;
    if (grouping && grouping === 'month') {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [day, month, year] = date.split('-');
      dateGroupped = `${month}-${year}`;
    } else {
      dateGroupped = date;
    }

    if (!map[dateGroupped]) {
      map[dateGroupped] = {
        date: dateGroupped,
        EXP_SUPER_ADMIN: 0,
        EXP_ADMIN: 0,
        EXP_PROJECT_CREATOR: 0,
      };
    }

    map[dateGroupped][user_role] += +number;
  }

  return Object.values(map) as {
    date: string;
    EXP_PROJECT_CREATOR: number;
    EXP_ADMIN: number;
    EXP_SUPER_ADMIN: number;
  }[];
};
